export default __webpack_public_path__ + "static/media/banner4en.397061d8.png";